<h2 mat-dialog-title>Upload file</h2>
<mat-dialog-content>
  @for (msg of (data.message || []); track msg) {
    <p>{{ msg }}</p>
  }
  <input type="file" (change)="onFileSelected($event)" accept=".json"/>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button (click)="onConfirm()" color="primary">{{ data.confirmLabel || 'OK' }}</button>
  <button mat-raised-button (click)="onCancel()">{{ data.cancelLabel || 'Cancel' }}</button>
</mat-dialog-actions>
